import { clsx } from 'clsx';

import CustomButton from '../common/buttons/custom-button';

import ordersUtils from '../../utils/OrdersUtils';
import useStyles from './OrderDetailDialogActionsBox.styles';
import { Box, Tooltip } from '@material-ui/core';

function OrderDetailDialogActionsBox(props) {
  const {
    classes = {},
    cancelButtonText,
    canceledMarketplaceOrderButtonText,
    canceledPickupOrderButtonText,
    deliveredToRTText,
    notDeliveredToRTText,
    onClickCanceledMarketplaceOrderButton,
    onClickCanceledPickupOrderButton,
    onClickDeliveredToRT,
    onClickNotDeliveredToRT,
    onClickOrderReadyButton,
    onClickDeliverButton,
    onClickRejectButton,
    order,
    orderReadyButtonText,
    packageDeliveredButtonText,
    sentToDeliverButtonText,
    partnerId,
    pendingToDeliverButtonText,
    showCanceledFullDeliveryOrderActions,
    showCanceledMarketplaceOrderActions,
    showCanceledPickupOrderActions,
    showCookingOrderActions,
    showPendingToDeliverOrderActions,
    storekeeperId,
    storeId,
    isOrderReadyButtonEnabled,
    orderReadyButtonDisclaimerText,
  } = props;

  const _clases = useStyles();
  const cookinglabelButton = ordersUtils.isMarketPlace(order.delivery_method)
    ? sentToDeliverButtonText
    : orderReadyButtonText;
  const pendingDeliverylabelButton = ordersUtils.isMarketPlace(
    order.delivery_method,
  )
    ? packageDeliveredButtonText
    : pendingToDeliverButtonText;

  return (
    <div className={clsx(_clases.root, classes?.root)}>
      {showCanceledFullDeliveryOrderActions && (
        <>
          <CustomButton
            classes={{ submitButton: _clases.customButtonSecondaryRoot }}
            onClick={async () => {
              await onClickNotDeliveredToRT(
                order.id,
                partnerId,
                storekeeperId,
                storeId,
              );
            }}
            variant='outlined'
          >
            {notDeliveredToRTText}
          </CustomButton>
          <CustomButton
            classes={{ submitButton: _clases.customButtonSecondaryRoot }}
            onClick={async () => {
              await onClickDeliveredToRT(
                order.id,
                partnerId,
                storekeeperId,
                storeId,
              );
            }}
            variant='outlined'
          >
            {deliveredToRTText}
          </CustomButton>
        </>
      )}
      {showCanceledMarketplaceOrderActions && (
        <CustomButton
          classes={{ submitButton: _clases.customButtonSecondaryRoot }}
          onClick={async () => {
            await onClickCanceledMarketplaceOrderButton(order.id);
          }}
          variant='outlined'
        >
          {canceledMarketplaceOrderButtonText}
        </CustomButton>
      )}
      {showCanceledPickupOrderActions && (
        <CustomButton
          classes={{ submitButton: _clases.customButtonSecondaryRoot }}
          onClick={async () => {
            await onClickCanceledPickupOrderButton(order.id);
          }}
          variant='outlined'
        >
          {canceledPickupOrderButtonText}
        </CustomButton>
      )}
      {showCookingOrderActions && (
        <>
          <CustomButton
            classes={{ submitButton: _clases.customButtonSecondaryRoot }}
            color='secondary'
            onClick={onClickRejectButton}
          >
            {cancelButtonText}
          </CustomButton>
          <OrderReadyButtonTooltipWrapper
            condition={!isOrderReadyButtonEnabled}
            wrapper={children => (
              <Tooltip
                classes={{ tooltip: _clases.tooltip }}
                title={orderReadyButtonDisclaimerText}
                placement='left-start'
                arrow
              >
                {children}
              </Tooltip>
            )}
          >
            <Box>
              <CustomButton
                onClick={async () => {
                  await onClickOrderReadyButton(order);
                }}
                variant='contained'
                disabled={!isOrderReadyButtonEnabled}
              >
                {cookinglabelButton}
              </CustomButton>
            </Box>
          </OrderReadyButtonTooltipWrapper>
        </>
      )}
      {showPendingToDeliverOrderActions && (
        <CustomButton
          onClick={async () => {
            await onClickDeliverButton(order.id);
          }}
          variant='contained'
        >
          {pendingDeliverylabelButton}
        </CustomButton>
      )}
    </div>
  );
}

export default OrderDetailDialogActionsBox;

function OrderReadyButtonTooltipWrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}
